import React , { useEffect }from 'react';
import '../LegalPages.css';
import background from '../assets/img2.png';

export function PrivacyPolicy() {
        useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="legal-page" style={{ backgroundImage: `url(${background})` }}>
            <div className="overlay" />
            <div className="legal-content">
                <h1>Política de Privacidad</h1>
                <p className="update-date">Última actualización: 15 de noviembre de 2025</p>

                <div className="legal-text">

                    <p>
                        ChefSkills ("nosotros", "nuestro" o "la app") se compromete a proteger tu privacidad.
                        Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información personal
                        cuando utilizas nuestra aplicación móvil ChefSkills.
                    </p>

                    <h2>1. Información que Recopilamos</h2>

                    <p><strong>1.1. Información Personal Identificable</strong></p>
                    <p>
                        A través de Google Sign-In y Firebase Authentication recopilamos:
                        nombre, correo electrónico y foto de perfil (opcional).
                    </p>

                    <p><strong>1.2. Datos de Uso</strong></p>
                    <p>
                        Mediante Firebase Analytics recopilamos información técnica como:
                        modelo del dispositivo, sistema operativo, pantallas visitadas, acciones dentro de la app,
                        tiempo de uso, rendimiento y errores (Crashlytics).
                    </p>

                    <p><strong>1.3. Datos de Localización</strong></p>
                    <p>
                        Solo si tú lo autorizas. Puede utilizarse para mejorar sugerencias o funcionalidades específicas.
                    </p>

                    <p><strong>1.4. Imágenes y Contenido Subido</strong></p>
                    <p>
                        Si subes fotos u otros contenidos, estos pueden almacenarse en Firebase Storage y sus metadatos
                        en Firestore.
                    </p>

                    <p><strong>1.5. Información de Suscripciones</strong></p>
                    <p>
                        Procesada por Google Play Billing. Incluye tipo de plan, estado y fecha de renovación.
                        ChefSkills no almacena datos de tarjetas ni métodos de pago.
                    </p>

                    <h2>2. Cómo Usamos tu Información</h2>

                    <p>
                        Utilizamos la información para:
                    </p>
                    <ul>
                        <li>Proveer las funcionalidades principales de la app.</li>
                        <li>Guardar preferencias, favoritos y progreso del usuario.</li>
                        <li>Personalizar contenido y sugerencias.</li>
                        <li>Mejorar la estabilidad, rendimiento y experiencia del usuario.</li>
                        <li>Analizar estadísticas y errores.</li>
                        <li>Gestionar suscripciones y funciones premium.</li>
                    </ul>

                    <p><strong>Nunca vendemos ni alquilamos tus datos personales.</strong></p>

                    <h2>3. Servicios de Terceros Que Utilizamos</h2>

                    <p>ChefSkills utiliza los siguientes servicios externos:</p>
                    <ul>
                        <li>Firebase Authentication</li>
                        <li>Firebase Firestore</li>
                        <li>Firebase Storage</li>
                        <li>Firebase Analytics</li>
                        <li>Firebase Crashlytics</li>
                        <li>Google Play Billing</li>
                        <li>Expo / React Native</li>
                    </ul>

                    <h2>4. Seguridad de los Datos</h2>

                    <p>
                        ChefSkills implementa medidas de seguridad como:
                        conexiones cifradas (HTTPS), protección mediante Firebase,
                        y controles de acceso. Aun así, ninguna plataforma es 100% segura.
                    </p>

                    <h2>5. Tus Derechos</h2>

                    <p>
                        Puedes solicitar:
                    </p>
                    <ul>
                        <li>Acceso a tus datos personales.</li>
                        <li>Corrección o actualización.</li>
                        <li>Eliminación de tu cuenta y datos asociados.</li>
                        <li>Información sobre el procesamiento de tus datos.</li>
                    </ul>

                    <p>
                        Para ejercer estos derechos contáctanos en:
                        <br /><strong>chefskills.app@gmail.com</strong>
                    </p>

                    <h2>6. Privacidad de Menores</h2>

                    <p>
                        ChefSkills no está destinada a menores de 13 años.
                        No recopilamos intencionalmente información de menores.
                        Si crees que un menor ha proporcionado datos, contáctanos.
                    </p>

                    <h2>7. Cambios a esta Política</h2>

                    <p>
                        Podemos actualizar esta Política de Privacidad ocasionalmente.
                        Notificaremos dentro de la app si se realizan cambios significativos.
                    </p>

                    <h2>8. Contacto</h2>

                    <p>
                        Si tienes preguntas sobre esta política, contáctanos:
                        <br /><strong>chefskills.app@gmail.com</strong>
                    </p>

                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
